<template>
	<div class="assemblyBgColor welfare" :class="sourceStr == 'isShare' ? 'sourceShare' : '' ">
		<div class="tit">预约福利</div>
		<div class="welfareContent">
			<div class="welfareMain" v-for="item in descProp" :key="item.propId">
				<div class="wfTtemMain">
					<div class="welfareItem">
						<img :src="item.icon" alt />
						<p>{{item.propName}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="welfareTxt">{{awardDesc}}</div>
	</div>
</template>

<script>
import Vue from 'vue';
import config from "@/../config";
import active from '@/utils/axios/index'
import { mapState } from "vuex";
import { Toast } from 'vant';
Vue.use(Toast);
export default {
	name: 'welfare',
	props: {
		sourceStr: { //标识哪个父组件引用
			type: String
		}
	},
	data() {
		return {
			descProp: [], //预约福利
			awardDesc: '', //描述
		}
	},
	computed: {
		...mapState([
			"activityId",
			"uuid"
		])
	},
	methods: {
		//获取预约信息
		subscribeInfo(params) {
			active.subscribeInfo(config.API_HOST + "/apiserv/api/activity/subscribe/subscribeInfo",{
				activityId: this.activityId,
				subscribeIdPointer: params,
				uuid: this.uuid
			}).then((res) => {
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
				}
				this.descProp = res.data.activityContentSubscribe.descProp;
				this.awardDesc = res.data.activityContentSubscribe.awardDesc;
				let appointmentInf = {
					onlineDesc: res.data.activityContentSubscribe.onlineDesc, //上线描述
					count: res.data.count, //预约人数
					subscribeStatus: res.data.subscribeStatus, //预约状态
					subscribeIdPointer: res.data.activityContentSubscribe.subscribeIdPointer, //预约模块大id
					online: res.data.online, //是否开放下载游戏
					awardId: res.data.activityContentSubscribe.awardId, //预约奖励id
					subscribeAwardStatus: res.data.subscribeAwardStatus, //是否已领取预约奖励
					subscribeConditionList: res.data.subscribeConditionList ,//预约流程
					gameId: res.data.activityContentSubscribe.gameId //游戏id
				};
				this.$emit('setAppointmentInf', appointmentInf)
			}).catch((error) => {
				this.$toast('网络不稳定，请稍后');
			});
		}
	}
}
</script>

<style scoped="scoped">
	.welfare{
		margin-top: 0.08rem;
		padding: 0.2rem 0.14rem;
	}
	.welfare .tit{
		font-size: 0.18rem;
		color: rgba(255,255,255,0.90);
	}
	.welfareContent{
		display: flex;
		flex-wrap: wrap;
		margin-top: 0.1rem;
	}
	.welfareMain{
		width: 25%;
		padding: 0.03rem;
	}
	.wfTtemMain{
		/* padding: 0.03125rem; */
		width: 100%;
		height: 0;
		padding-top: 100%;
		position: relative;
	}
	.welfareItem{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 100%;
		height: 100%;
		background-color: rgba(255,255,255,0.05);
		border-radius: 0.08rem;
		position: absolute;
		top: 0;
		left: 0;
	}
	.welfareItem img{
		width: 0.38rem;
		height: 0.38rem;
		border-radius: 0.04rem;
	}
	.welfareItem p{
		color: rgba(255,255,255,0.87);
		font-size: 0.12rem;
		margin-top: 0.05rem;
	}
	.welfareTxt{
		color: rgba(255,255,255,0.60);
		font-size: 0.14rem;
		margin-top: 0.1rem;
	}
	.sourceShare .tit{
		color: #333;
		font-weight: bold;
	}
	.sourceShare .welfareItem{
		background-color: #F5F5F5;
	}
	.sourceShare .welfareItem p{
		color: #333;
	}
	.sourceShare .welfareTxt{
		color: #666666;
	}
</style>
